/** Two letters for an avatar, from whatever name a person offers. Shared by
 *  the board card and the roadmap's owner avatar so the same person always
 *  gets the same mark. */
export function initials(name?: string | null): string {
  const parts = String(name || "").trim().split(/\s+/);
  return (parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "");
}
